
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.805 5.528L12 1.724 8.195 5.528l.943.943 2.195-2.195V14h1.334V4.276l2.195 2.195.943-.943zM3.333 11.919L1.138 9.724l-.943.943L4 14.472l3.805-3.805-.943-.943-2.195 2.195V2.083H3.333v9.836z"}}),_c('mask',{staticStyle:{"mask-type":"luminance"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"2","width":"8","height":"13"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.333 11.919L1.138 9.724l-.943.943L4 14.472l3.805-3.805-.943-.943-2.195 2.195V2.083H3.333v9.836z"}})])])
          )
        }
      }
    